<template>
  <div>
    <el-container>
      <el-header>
        <el-input v-model="serchat" placeholder="请输入关键字" maxlength="30" style="width: 150px;"></el-input>
        <el-button type="primary" @click="isAjax" plain>查询</el-button>&nbsp;&nbsp;|
        <el-button type="primary" @click="upDateFanList" plain>更新数据</el-button>
      </el-header>
      <el-main v-loading.fullscreen.lock="fullscreenLoading">
        <template>
          <el-table
            :data="tableData"
            @selection-change="handleSelectionChange"
            border
            :height="divHeight"
            style="width: 100%">
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>
            <el-table-column
              fixed
              prop="nickname"
              label="昵称"
              width="150">
            </el-table-column>
            <el-table-column
              prop="weChatUserPlatform[0].authorizer_info.nick_name"
              label="公众号名称"
              width="150">
            </el-table-column>
            <el-table-column
              prop="sex"
              label="性别"
              width="80">
              <template slot-scope="scope">
                <span v-html="isSex(scope.row.sex)"></span>
              </template>
            </el-table-column>
            <el-table-column
              prop="country"
              label="所在国家"
              width="150">
            </el-table-column>
            <el-table-column
              prop="province"
              label="所在省份"
              width="150">
            </el-table-column>
            <el-table-column
              prop="city"
              label="所在城市"
              width="150">
            </el-table-column>
            <el-table-column
              prop="headimgurl"
              label="头像"
              width="200">
              <template slot-scope="scope">
                <img :src="scope.row.headimgurl" class="headimgurl" />
              </template>
            </el-table-column>
            <el-table-column
              prop="subscribe_time"
              :formatter="formatTime"
              label="关注时间"
              width="250">
            </el-table-column>
          </el-table>
        </template>
      </el-main>
      <el-footer>
        <el-pagination
          background
          @size-change="handleSizeChange0"
          @current-change="handleCurrentChange0"
          :current-page="currentPage0"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="count0"
          layout="total, sizes, prev, pager, next, jumper"
          :total="allcount0">
        </el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
  export default {
    name: 'fanManage',
    data(){
      return {
        serchat:"",
        timeNull:null,
        fullscreenLoading: false,
        allcount0:0,//总页数 对应 total
        count0:100,//一页显示多少量 对应 page-size
        currentPage0:1,//当前页数
        divHeight:500,
        tableData:[]
      }
    },
    components: {
    },
    methods:{
      isSex(sex){
        return sex == "1"?"男":"女"
      },
      formatTime:function(row, column) {
        var date = new Date(parseInt(row[column.property]+'000'));
        var format = "yyyy-MM-dd hh:mm:ss";
        var o = {
          "M+" : date.getMonth()+1, //month
          "d+" : date.getDate(),    //day
          "h+" : date.getHours(),   //hour
          "m+" : date.getMinutes(), //minute
          "s+" : date.getSeconds(), //second
          "q+" : Math.floor((date.getMonth()+3)/3),  //quarter
          "S" : date.getMilliseconds() //millisecond
        };
        if(/(y+)/.test(format)) format=format.replace(RegExp.$1,
          (date.getFullYear()+"").substr(4 - RegExp.$1.length));
        for(var k in o)if(new RegExp("("+ k +")").test(format))
          format = format.replace(RegExp.$1,
            RegExp.$1.length==1 ? o[k] :
              ("00"+ o[k]).substr((""+ o[k]).length));
        return format;
      },
      isAjax:async function(){
        await this.$axios.post('/data/addFansList',{
          s:this.serchat,
          "count":this.count0,
          "page":this.currentPage0
        }).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            this.tableData = response.data[0];
            this.allcount0 = response.data[1];
            this.divHeight = window.innerHeight-158;
          }else if(response.data.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }else{
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          this.$message.error(error);
        });
      },
      upDateFanList:async function(){
        this.fullscreenLoading = true;
        try{
          await this.$axios.post('/data/upDateFanList',{}).then((response,err) => {
            this.fullscreenLoading = false;
            response = response.data;
            if(response.code == "Login" || response.code == "WhiteList"){
              this.$message.error(response.message);
            }else if(response.code == "Success"){
              var mess = response.data;
              if(mess.count != 0 && mess.count != mess.total){
                this.upDateFanList();
              }
              const h = this.$createElement;
              this.$notify({
                title: '更新成功信息',
                message: h('i', { style: 'color: teal'}, '公众号总粉丝数量：'+mess.total+',本次更新新增粉丝数量：'+mess.count)
              });
              clearInterval(this.timeNull)
              this.startGetOpenidData();
            }else if(response.data.code == "Fail"){
              this.$message({
                message: response.message,
                type: 'warning'
              });
            }else{
              this.$message({
                message: response.message,
                type: 'warning'
              });
            }
          }).catch(function (error) {
            this.fullscreenLoading = false;
            this.$message.error(error);
          });
        }catch (e){
          this.fullscreenLoading = false;
        }
      },
      handleSizeChange0(val) {
        this.count0 = val;
        this.isAjax();
      },
      handleCurrentChange0(val) {
        this.currentPage0 = val;
        this.isAjax();
      },
      handleSelectionChange(val) {
        /*this.multipleSelection = val;
        for(var m=0;m<((this.multipleSelection).length);m++){
          this.prodictIdArr.push(this.multipleSelection[m]._id);
        }*/
      },
      startGetOpenidData(){
        var _this = this;
        _this.timeNull = setInterval(async function () {
          try{
            await _this.$axios.post('/data/upDateFanMess',{}).then((response,err) => {
              response = response.data;
              if(response.code == "Login" || response.code == "WhiteList"){
                clearInterval(_this.timeNull)
              }else if(response.code == "Success"){
                _this.isAjax();
              }else if(response.data.code == "Fail"){
                clearInterval(_this.timeNull)
              }else{
                clearInterval(_this.timeNull)
              }
            }).catch(function (error) {
              clearInterval(_this.timeNull)
              this.$message.error(error);
            });
          }catch (e){
            console.log(e);
            clearInterval(_this.timeNull)
            _this.timeNull = null;
          }
        },5000);
      }
    },
    mounted(){
      this.isAjax();
      //定时更新openid 信息
      this.startGetOpenidData()
    }
  }
</script>
<style scoped>
  body{
    padding: 0;
    margin: 0;
  }
  .headimgurl{
    width: 100px;
    height: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/views/weChatPlatfrom/fanManage.vue